export enum ROLE {
  ADMIN = 'Admin',
  TENANT = 'TENANT',
  TENANT_MARKETING = 'TENANT_MARKETING',
  TENANT_IT = 'TENANT_IT',
  TENANT_FINANCE = 'TENANT_FINANCE',
  TENANT_MANAGEMENT = 'TENANT_MANAGEMENT',
  TENANT_PR = 'TENANT_PR',
  ACCOMMODATION = 'ACCOMMODATION',
  ACCOMMODATION_OPERATOR = 'ACCOMMODATION_OPERATOR',
  SERVICE = 'SERVICE',
  CHANNEL = 'CHANNEL',
  CHANNEL_ADMIN = 'CHANNEL_ADMIN',
  PMS_SERVICE = 'PMS_SERVICE',
  CHANNEL_ACTIVATION = 'CHANNEL_ACTIVATION',
  PROVIDER = 'PROVIDER',
  PROVIDER_IT = 'PROVIDER_IT',
  PROVIDER_MARKETING = 'PROVIDER_MARKETING',
  PROVIDER_FINANCE = 'PROVIDER_FINANCE',
  PROVIDER_MANAGEMENT = 'PROVIDER_MANAGEMENT',
  PROVIDER_PR = 'PROVIDER_PR'
}

export const allRoles: ROLE[] = [
  ROLE.ADMIN,
  ROLE.TENANT,
  ROLE.TENANT_MARKETING,
  ROLE.PROVIDER_MARKETING,
  ROLE.TENANT_IT,
  ROLE.PROVIDER_IT,
  ROLE.TENANT_FINANCE,
  ROLE.PROVIDER_FINANCE,
  ROLE.TENANT_MANAGEMENT,
  ROLE.PROVIDER_MANAGEMENT,
  ROLE.TENANT_PR,
  ROLE.PROVIDER_PR,
  ROLE.ACCOMMODATION,
  ROLE.ACCOMMODATION_OPERATOR,
  ROLE.SERVICE,
  ROLE.CHANNEL,
  ROLE.CHANNEL_ADMIN,
  ROLE.CHANNEL_ACTIVATION,
  ROLE.PMS_SERVICE,
  ROLE.PROVIDER,
  ROLE.PROVIDER_FINANCE,
  ROLE.PROVIDER_IT,
  ROLE.PROVIDER_MANAGEMENT,
  ROLE.PROVIDER_MARKETING,
  ROLE.PROVIDER_PR
]

export type RouteWithAccessType = {
  route: string
  exact: boolean
  rolesListWithReadAccess?: ROLE[]
  rolesListWithWriteAccess?: ROLE[]
  requiredFeatures?: string[]
  component: JSX.Element
  tabs?: {
    params: Record<string, string>
    rolesListWithReadAccess?: ROLE[]
    rolesListWithWriteAccess?: ROLE[]
    requiredFeatures?: string[]
    sections?: Record<
      string,
      {
        rolesListWithReadAccess?: ROLE[]
        rolesListWithWriteAccess?: ROLE[]
        requiredFeatures?: string[]
      }
    >
  }[]
  sections?: Record<
    string,
    {
      rolesListWithReadAccess?: ROLE[]
      rolesListWithWriteAccess?: ROLE[]
      requiredFeatures?: string[]
    }
  >
}
